import { SxProps, Theme } from '@mui/material'
import localeText from '../../../../locales/datagrid'
import {
    GridFilterItemPro,
    GridFilterModelPro,
    LinkOperator,
} from '../utils/filterModelPro'
import FilterPanelSelect from './PanelSelect'
import React from 'react'

export default function FieldLinkOperator({
    item,
    onFilterModelChange,
    sx,
}: {
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    sx?: SxProps<Theme>
}) {
    return (
        <FilterPanelSelect
            label=""
            options={[
                {
                    value: LinkOperator.And,
                    label: localeText.filterPanelOperatorAnd,
                },
                {
                    value: LinkOperator.Or,
                    label: localeText.filterPanelOperatorOr,
                },
            ]}
            value={item.linkOperator || LinkOperator.And}
            sx={sx}
            onChange={e => {
                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id
                            ? {
                                  ...p,
                                  linkOperator: e.target.value as LinkOperator,
                              }
                            : p,
                    ),
                }))
            }}
        />
    )
}
